import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';
import useStyles from "@hooks/useStyles";
import CommonDrawer from './CommonDrawer';

const drawerWidth = 240;

export default function AdminDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)

  const sideMenu = [
    // {text:'Test',     to:'/scm/test'},
    
    {text:'divider', visible: true},
    {text:'직영등록 신청현황',   to:'/admin/direct/assign', visible: true},
    {text:'업체등록 신청현황',   to:'/admin/company/condition', visible: true},
    {text:'위탁등록 신청현황',   to:'/admin/company/assign', visible: true},
    {text:'약관',   to:'/admin/agmt', visible: true},
    {text:'학교',   to:'/admin/school', visible: true},
    {text:'위탁업체',   to:'/admin/company', visible: true},
    {text:'사용자',    to:'/admin/user', visible: true}, 
    {text:'학생',      to:'/admin/student', visible: true}, 
    {text:'학기',     to:'/admin/smst',visible: true },
    // {text:'강좌',     to:'/admin/lecture'},
    // {text:'수강신청 현황',   to:'/admin/regi' },
    // {text:'수강신청 마감' , to:'/admin/regi2'},
    // {text:'출석부',     to:'/admin/attdnc'},
    // {text:'설문조사',     to:'/scm/attdnc'},
  ]

  return (
    <CommonDrawer sideMenu={sideMenu}  title={'어드민'} barBgColor='#214499'/>
	)
}
